import type { FC } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import useCookie from "../logic/cookie";

const LOCATION_PATH = {
  HOME: "/home",
  MANAGEMENT: "/management",
  ORDERLIST: "/orderlist",
};

const SidePanel: FC = () => {
  const [cookieData] = useCookie();
  const location = useLocation();
  const currentPath = location.pathname;

  const isCurrent = (path: string) => currentPath === path;
  const canShow = (path: string) => {
    if (path === LOCATION_PATH.HOME) return cookieData.permission2 > 0;
    if (path === LOCATION_PATH.ORDERLIST) return cookieData.permission3 > 0;
    if (path === LOCATION_PATH.MANAGEMENT) return cookieData.permission1 > 0;
    return false;
  };
  const btnName = (path: string) => {
    if (path === LOCATION_PATH.HOME) return "ホーム";
    if (path === LOCATION_PATH.ORDERLIST) return "発注一覧";
    if (path === LOCATION_PATH.MANAGEMENT) return "設定";
    return "";
  };

  const paths = [LOCATION_PATH.HOME, LOCATION_PATH.ORDERLIST, LOCATION_PATH.MANAGEMENT];

  const navigate = useNavigate();

  return (
    <>
      <div className={"app-sidebar"}>
        {paths.map(p => (
          <>
            {canShow(p) && (
              <button className={isCurrent(p) ? "select" : ""} onClick={() => navigate(p)}>
                {btnName(p)}
              </button>
            )}
          </>
        ))}
      </div>
    </>
  );
};

export default SidePanel;
